import { useAreaUnits } from '$contexts/area-units';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/properties.d.ts').PropertyAreaText}
 */
export const PropertyAreaText = ({
    isOffMarket,
    areaMeters,
    prefix = '',
    suffix = '',
}) => {
    const { unit, convertUnitOfArea } = useAreaUnits() || {};

    if (isOffMarket) { return null; }

    const livingArea = unit ? convertUnitOfArea({ amount: areaMeters || 0, from: 'sqm', to: unit }) : areaMeters;
    const livingAreaDisplay = livingArea ? `${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(livingArea)} ${unit}` : null;

    return prefix + livingAreaDisplay + suffix;
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default PropertyAreaText;
